import { observable, decorate } from "mobx";
import { formatRoundDesc, parseRoundDate } from "./dayjs";
import { roundHandicapForScoring } from "./theme";

class EWTStore {
  players = null;
  rounds = null;
  courses = null;
  firebaseDB = null;
  firebaseStorage = null;
  showView = "";
  tournament = null;
  player = null;
  course = null;
  chatMessages = null;
  org = null;
  panelHeight = 0;
  panelWidth = 0;
  golfcourseImageURL = null;
  showPlayerCard = null;
  showPlayerEdit = false;
  editPlayer = null;
  playerEditKey = 0;
  playersListRefresh = null;
  groupPlayers = null;
  windowHeight = window.innerHeight;
  windowWidth = window.innerWidth;
  currentView = "leaderboard";
  color1 = "#1565C8";
  color2 = "#D32F2F";
  color3 = "#059669";
  color4 = "#9f9d4b";
  color5 = "#ae5b42";
  fanMode = false;
  fanTournaments = null;
  allTournaments = null;
  showMap = false;
  courseMapURL = null;
  roundScores = null;
  scores = null;
  currentRoundID = null;
  initialized = false;
  adminUser = false;
  sortedPlayers = null;
  editRounds = false;
  gallery = false;
  unread = { chats: false, pics: false };
  correctScore = null;
  currentRound = {};
  mapIconURL = null;
  showHole = null;
  showFullPic = null;
  holeMapURL = null;
  showCourseMap = false;
  showCourseCard = false;
  showTieBreaker = false;
  showPairings = false;
  showPlayers = false;
  showItinerary = false;
  logoURL = null;
  deferredInstallPrompt = null;
  usingKeyboard = null;
  usingKeyboardStart = null;
  firstRoundID = null;
  selectTournament = false;
  playerFullTournamentsLoading = false;
  playersSnapshotUnsubscribe = null;
  tournamentSnapshotUnsubscribe = null;
  roundsSnapshotUnsubscribe = null;
  scoresSnapshotUnsubscribes = null;
  scoresSubscribedRoundIds = null;
  scoresInitialSnapshotPending = 0;
  playersPictureLoadGeneration = 0;
  playerPicturesMissing = {};

  setCookieValue(key, value) {
    document.cookie =
      key +
      "=" +
      value +
      ";expires=Fri, 30 Dec 2050 12:00:00 UTC;;SameSite=Strict";
  }

  syncViewportSize() {
    const vv = window.visualViewport;
    const width = Math.round(vv ? vv.width : window.innerWidth);
    const height = Math.round(vv ? vv.height : window.innerHeight);
    this.windowWidth = width;
    this.windowHeight = height;
    this.panelHeight = Math.max(200, height - 190);
    this.panelWidth = width <= 600 ? width - 24 : 400;
  }

  resetViewportAfterKeyboard() {
    if (
      document.activeElement &&
      document.activeElement !== document.body &&
      typeof document.activeElement.blur === "function"
    ) {
      document.activeElement.blur();
    }
    window.scrollTo(0, 0);
    this.syncViewportSize();
    window.setTimeout(() => this.syncViewportSize(), 100);
    window.setTimeout(() => this.syncViewportSize(), 350);
  }
  getCookieValue(key) {
    var name = key + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
  }

  unsubscribeTournament() {
    if (this.tournamentSnapshotUnsubscribe) {
      this.tournamentSnapshotUnsubscribe();
      this.tournamentSnapshotUnsubscribe = null;
    }
  }

  unsubscribeRounds() {
    if (this.roundsSnapshotUnsubscribe) {
      this.roundsSnapshotUnsubscribe();
      this.roundsSnapshotUnsubscribe = null;
    }
  }

  logOut() {
    this.unsubscribeScores();
    this.unsubscribeTournament();
    this.unsubscribeRounds();
    if (this.playersSnapshotUnsubscribe) {
      this.playersSnapshotUnsubscribe();
      this.playersSnapshotUnsubscribe = null;
    }
    this.playersPictureLoadGeneration += 1;
    this.setCookieValue("playerID", "");
    this.setCookieValue("fanMode", "");
    this.fanMode = false;
    this.player = null;
    this.adminUser = false;
    this.tournament = null;
    this.players = null;
    this.rounds = null;
    this.roundScores = null;
    this.scores = null;
    this.sortedPlayers = null;
    this.currentRoundID = null;
    this.currentRound = {};
    this.course = null;
    this.groupPlayers = null;
    this.initialized = false;
    this.showView = "SETUP";
  }

  async setOrg(orgID, org) {
    if (org) {
      this.org = org;
      this.setCookieValue(orgID, org.id);
    }
    this.org = await this.getOneDoc("orgs", orgID);
    if (this.org) this.setCookieValue("orgID", this.org.id);
  }

  calcGroup() {
    var round = this.rounds[this.currentRoundID];
    if (!round.players) return null;
    var player = round.players[this.player.id];
    if (!player) return;
    var groupID = player.groupID;
    this.group = round.groups[groupID];
    this.group.id = groupID;
    if (!this.group) alert("Couldn't calculate a group");
    this.groupPlayers = [];
    this.groupplayers = {};
    Object.keys(round.players).forEach((key) => {
      if (round.players[key].groupID === groupID) {
        this.groupPlayers.push(this.players[key]);
        this.groupplayers[key] = this.players[key];
      }
    });
  }

  setRoundOpenStatus(roundID, open) {
    this.firebaseDB.collection("rounds").doc(roundID).update({
      open: open,
    });
    this.rounds[this.currentRoundID].open = open;
  }

  initializeRounds(tournament) {
    var that = this;
    that.unsubscribeRounds();
    that.firstRoundID = null;
    that.rounds = {};
    return (async function () {
      const snapshot = await that.firebaseDB
        .collection("rounds")
        .where("tournamentID", "==", tournament.id)
        .orderBy("roundNumber")
        .get();
      snapshot.docs.forEach(function (doc) {
        that.applyRoundDoc(doc.data(), doc.id);
      });
      that.roundsSnapshotUnsubscribe = that.firebaseDB
        .collection("rounds")
        .where("tournamentID", "==", tournament.id)
        .orderBy("roundNumber")
        .onSnapshot(function (snap) {
          snap.docChanges().forEach(function (change) {
            if (change.type === "removed") {
              delete that.rounds[change.doc.id];
              return;
            }
            that.applyRoundDoc(change.doc.data(), change.doc.id);
          });
          if (that.initialized) {
            that.setSortedPlayers();
            if (
              !that.fanMode &&
              that.currentRoundID &&
              that.rounds[that.currentRoundID]
            ) {
              that.calcGroup();
            }
          }
        });
    })();
  }

  applyRoundDoc(round, roundID) {
    round.desc = formatRoundDesc(round);
    round.id = roundID;
    if (round.players) {
      Object.keys(round.players).forEach((playerID) => {
        round.players[playerID].id = playerID;
      });
    }
    if (!this.firstRoundID && !round.practice) this.firstRoundID = round.id;
    this.rounds[round.id] = round;
    if (round.courseID) {
      this.ensureCourse(round.courseID);
    }
  }

  showHoleMap(holeNumber) {
    var that = this;
    this.firebaseStorage
      .ref("images/courses/" + this.course.id + "/")
      .child("h" + holeNumber + ".jpg")
      .getDownloadURL()
      .then((url) => {
        that.holeMapURL = url;
      });
    that.showHole = holeNumber;
  }

  initializeScores(tournament) {
    this.roundScores = {};
    this.scores = {};
    return this.refreshScoresSubscription(tournament);
  }

  unsubscribeScores() {
    if (this.scoresSnapshotUnsubscribes) {
      this.scoresSnapshotUnsubscribes.forEach(function (unsub) {
        unsub();
      });
      this.scoresSnapshotUnsubscribes = null;
    }
    this.scoresSubscribedRoundIds = null;
    this.scoresInitialSnapshotPending = 0;
    this.scoresPendingUpdates = null;
    this.scoresInitialLoadDone = null;
  }

  getNonPracticeRoundIds() {
    if (!this.rounds) return [];
    return Object.keys(this.rounds).filter(
      (roundID) => !this.rounds[roundID].practice
    );
  }

  getScoreRoundIdsForCurrentRound() {
    const rounds = this.getCurrentRounds();
    if (rounds.length) {
      return rounds.map((round) => round.id);
    }
    return this.getNonPracticeRoundIds();
  }

  mergeScoreDoc(score, scoreID, changeType, needsUpdate) {
    if (!this.scores) this.scores = {};
    var roundID = score.roundID;
    var playerID = score.playerID;
    var hole = parseInt(score.hole, 10);
    if (!roundID || !playerID || !hole) return;
    if (changeType === "removed") {
      if (this.scores[roundID] && this.scores[roundID][playerID]) {
        delete this.scores[roundID][playerID][hole];
      }
      if (!needsUpdate[roundID]) needsUpdate[roundID] = {};
      needsUpdate[roundID][playerID] = true;
      return;
    }
    score.id = scoreID;
    if (!this.scores[roundID]) this.scores[roundID] = {};
    if (!this.scores[roundID][playerID]) this.scores[roundID][playerID] = {};
    this.scores[roundID][playerID][hole] = score;
    if (!needsUpdate[roundID]) needsUpdate[roundID] = {};
    needsUpdate[roundID][playerID] = true;
  }

  async processScoreUpdates(needsUpdate) {
    const courseIDs = new Set();
    Object.keys(needsUpdate).forEach((roundID) => {
      const round = this.rounds && this.rounds[roundID];
      if (round && round.courseID) courseIDs.add(round.courseID);
    });
    if (courseIDs.size) {
      await Promise.all(
        [...courseIDs].map((courseID) => this.ensureCourse(courseID))
      );
    }
    Object.keys(needsUpdate).forEach((roundID) => {
      Object.keys(needsUpdate[roundID]).forEach((playerID) => {
        this.recalculateRoundScoresForPlayer(roundID, playerID);
      });
    });
    this.setSortedPlayers();
  }

  roundHasScores(roundID) {
    if (!roundID || !this.roundScores || !this.roundScores[roundID]) return false;
    return Object.keys(this.roundScores[roundID]).some((playerID) => {
      const playerScores = this.roundScores[roundID][playerID];
      if (!playerScores) return false;
      for (let hole = 1; hole <= 18; hole++) {
        if (playerScores[hole] && playerScores[hole].strokes != null) return true;
      }
      return false;
    });
  }

  handleScoresSnapshot(snapshot) {
    var that = this;
    if (that.scoresInitialSnapshotPending > 0) {
      if (!that.scoresPendingUpdates) that.scoresPendingUpdates = {};
      snapshot.docs.forEach(function (doc) {
        that.mergeScoreDoc(doc.data(), doc.id, "added", that.scoresPendingUpdates);
      });
      that.scoresInitialSnapshotPending -= 1;
      if (that.scoresInitialSnapshotPending > 0) {
        return;
      }
      const pending = that.scoresPendingUpdates;
      that.scoresPendingUpdates = null;
      that.processScoreUpdates(pending)
        .then(function () {
          if (that.scoresInitialLoadDone) that.scoresInitialLoadDone();
        })
        .catch(function (err) {
          console.error("score updates", err);
          if (that.scoresInitialLoadDone) that.scoresInitialLoadDone(err);
        });
      return;
    }
    var needsUpdate = {};
    snapshot.docChanges().forEach(function (change) {
      that.mergeScoreDoc(
        change.doc.data(),
        change.doc.id,
        change.type,
        needsUpdate
      );
    });
    that.processScoreUpdates(needsUpdate).catch(function (err) {
      console.error("score updates", err);
    });
  }

  refreshScoresSubscription(tournament) {
    if (!tournament) tournament = this.tournament;
    if (!tournament) return Promise.resolve(true);
    this.unsubscribeScores();
    var roundIds = this.getScoreRoundIdsForCurrentRound();
    this.scoresSubscribedRoundIds = roundIds.slice();
    if (!roundIds.length) {
      return Promise.resolve(true);
    }
    var that = this;
    var chunks = [];
    for (var i = 0; i < roundIds.length; i += 30) {
      chunks.push(roundIds.slice(i, i + 30));
    }
    that.scoresInitialSnapshotPending = chunks.length;
    that.scoresPendingUpdates = {};
    return new Promise(function (resolve, reject) {
      that.scoresInitialLoadDone = function (err) {
        that.scoresInitialLoadDone = null;
        if (err) reject(err);
        else resolve(true);
      };
      that.scoresSnapshotUnsubscribes = chunks.map(function (chunk) {
        return that.firebaseDB
          .collection("scores")
          .where("tournamentID", "==", tournament.id)
          .where("roundID", "in", chunk)
          .onSnapshot(function (snapshot) {
            that.handleScoresSnapshot(snapshot);
          });
      });
    });
  }

  async ensureRoundScoresLoaded(roundID) {
    if (!roundID || !this.rounds || !this.rounds[roundID] || !this.tournament) {
      return;
    }
    if (
      this.scoresSubscribedRoundIds &&
      this.scoresSubscribedRoundIds.indexOf(roundID) >= 0
    ) {
      return;
    }
    if (
      this.scores &&
      this.scores[roundID] &&
      Object.keys(this.scores[roundID]).length > 0
    ) {
      return;
    }
    const snapshot = await this.firebaseDB
      .collection("scores")
      .where("tournamentID", "==", this.tournament.id)
      .where("roundID", "==", roundID)
      .get();
    const needsUpdate = {};
    var that = this;
    snapshot.docs.forEach(function (doc) {
      that.mergeScoreDoc(doc.data(), doc.id, "added", needsUpdate);
    });
    await this.processScoreUpdates(needsUpdate);
  }

  recalculateRoundScoresForPlayer(roundID, playerID) {
    if (!this.rounds[roundID] || !this.courses) return;
    const course = this.courses[this.rounds[roundID].courseID];
    if (!course) return;
    if (!this.scores || !this.scores[roundID] || !this.scores[roundID][playerID]) {
      return;
    }
    if (!this.roundScores[roundID]) this.roundScores[roundID] = {};
    var back = 0;
    var front = 0;
    var holeScores = {};
    for (var i = 0; i < 18; i++) {
      var hole = i + 1;
      var playerScore = this.scores[roundID][playerID][hole];
      if (playerScore) {
        var score = playerScore.score;
        if (hole < 10) front += score;
        if (hole >= 10) back += score;
        var strokes = this.getNet(
          playerID,
          course,
          this.rounds[roundID],
          hole,
          score
        );
        if (strokes == null) continue;
        playerScore.strokes = strokes;
        holeScores[hole] = playerScore;
      }
    }
    holeScores["B"] = back;
    holeScores["F"] = front;
    holeScores["T"] = back + front;
    this.roundScores[roundID][playerID] = holeScores;
  }

  recalculateScoresForPlayer(playerID, tournamentID) {
    if (!this.initialized || !tournamentID) return;
    Object.keys(this.rounds || {}).forEach((roundID) => {
      const round = this.rounds[roundID];
      if (round && round.tournamentID === tournamentID) {
        this.recalculateRoundScoresForPlayer(roundID, playerID);
      }
    });
    this.setSortedPlayers();
  }

  getCurrentRounds() {
    var rounds = [];
    var currentRound =
      this.currentRoundID && this.rounds[this.currentRoundID];
    if (!currentRound) return rounds;
    if (currentRound.practice) {
      //if it's a practice round - only show that everywhere
      rounds = [currentRound];
    } else {
      Object.keys(this.rounds).forEach((roundID) => {
        var round = this.rounds[roundID];
        if (!round.practice) {
          //only use real rounds
          if (round.roundNumber <= currentRound.roundNumber) {
            rounds.push(round);
          }
        }
      });
    }
    return rounds;
  }

  getHolesByHandicap(course, round) {
    if (!course || !round || !course.holes) return [];
    const holes = [];
    for (let holeNumber = 1; holeNumber <= 18; holeNumber++) {
      const tee = course.holes[holeNumber] && course.holes[holeNumber].tees
        ? course.holes[holeNumber].tees[round.tees]
        : null;
      if (!tee || tee.handicap == null || tee.handicap === "") continue;
      holes.push({
        holeNumber,
        handicap: parseInt(tee.handicap, 10),
      });
    }
    holes.sort((a, b) => {
      if (a.handicap !== b.handicap) return a.handicap - b.handicap;
      return a.holeNumber - b.holeNumber;
    });
    return holes;
  }

  getPlayerRoundNetTotal(playerID, roundID) {
    const targetRoundID =
      roundID || this.currentRoundID;
    if (!targetRoundID) return null;
    const playerScores =
      this.roundScores[targetRoundID] &&
      this.roundScores[targetRoundID][playerID];
    if (!playerScores) return null;
    let total = null;
    for (let hole = 1; hole <= 18; hole++) {
      if (playerScores[hole] && playerScores[hole].strokes != null) {
        if (total === null) total = 0;
        total += playerScores[hole].strokes;
      }
    }
    return total;
  }

  getPlayerNonPracticeNetTotal(playerID) {
    const currentRound =
      this.currentRoundID && this.rounds[this.currentRoundID];
    const currentRoundNumber =
      currentRound && !currentRound.practice
        ? parseInt(currentRound.roundNumber, 10)
        : null;
    let total = null;
    Object.keys(this.rounds || {}).forEach((roundID) => {
      const round = this.rounds[roundID];
      if (!round || round.practice) return;
      const roundNumber = parseInt(round.roundNumber, 10);
      if (
        currentRoundNumber != null &&
        !isNaN(currentRoundNumber) &&
        !isNaN(roundNumber) &&
        roundNumber > currentRoundNumber
      ) {
        return;
      }
      const playerScores =
        this.roundScores[roundID] && this.roundScores[roundID][playerID];
      if (!playerScores) return;
      for (let hole = 1; hole <= 18; hole++) {
        if (playerScores[hole] && playerScores[hole].strokes != null) {
          if (total === null) total = 0;
          total += playerScores[hole].strokes;
        }
      }
    });
    return total;
  }

  formatNetTotal(total) {
    if (total === null) return "";
    if (total > 0) return "+" + total;
    if (total === 0) return "E";
    return String(total);
  }

  getHandicapStrokesOnHole(playerHandicap, course, round, holeNumber) {
    if (!course || !round || !course.holes || !course.holes[holeNumber]) return 0;
    if (playerHandicap == null || playerHandicap === "") playerHandicap = 0;
    playerHandicap = roundHandicapForScoring(playerHandicap);

    const courseHole = course.holes[holeNumber];
    const tee = courseHole.tees && courseHole.tees[round.tees];
    if (!tee) return 0;

    const holeHandicap = parseInt(tee.handicap, 10);
    let strokes = 0;
    if (playerHandicap >= 18) strokes += 1;
    if (playerHandicap >= 36) strokes += 1;
    if (playerHandicap >= 54) strokes += 1;
    const holeHcpIndex = playerHandicap % 18;
    if (holeHcpIndex >= holeHandicap) strokes += 1;
    return strokes;
  }

  getPlayerActualNetOnHole(playerID, roundID, holeNumber) {
    const round = this.rounds[roundID];
    if (!round) return null;
    const course = this.courses[round.courseID];
    if (!course) return null;
    const holeScore =
      this.roundScores[roundID] &&
      this.roundScores[roundID][playerID] &&
      this.roundScores[roundID][playerID][holeNumber];
    if (!holeScore || holeScore.score == null) return null;

    const tee =
      course.holes[holeNumber] &&
      course.holes[holeNumber].tees &&
      course.holes[holeNumber].tees[round.tees];
    if (!tee) return null;

    let gross = holeScore.score;
    if (gross > tee.par * 2) gross = tee.par * 2;

    const playerHandicap =
      this.players[playerID] &&
      this.players[playerID].handicaps &&
      this.players[playerID].handicaps[this.tournament.id] != null
        ? this.players[playerID].handicaps[this.tournament.id]
        : 0;
    const strokesReceived = this.getHandicapStrokesOnHole(
      playerHandicap,
      course,
      round,
      holeNumber
    );
    return gross - strokesReceived;
  }

  getPlayerThreeHardestHolesTotals(playerID, roundID, holesByHandicap) {
    if (!holesByHandicap || holesByHandicap.length < 3) return null;
    let netTotal = 0;
    let grossTotal = 0;
    for (let i = 0; i < 3; i++) {
      const holeNumber = holesByHandicap[i].holeNumber;
      const holeScore =
        this.roundScores[roundID] &&
        this.roundScores[roundID][playerID] &&
        this.roundScores[roundID][playerID][holeNumber];
      if (!holeScore || holeScore.score == null) return null;
      const actualNet = this.getPlayerActualNetOnHole(
        playerID,
        roundID,
        holeNumber
      );
      if (actualNet == null) return null;
      netTotal += actualNet;
      grossTotal += holeScore.score;
    }
    return { net: netTotal, gross: grossTotal };
  }

  getPlayerNetOnHole(playerID, roundID, holeNumber) {
    const holeScore =
      this.roundScores[roundID] &&
      this.roundScores[roundID][playerID] &&
      this.roundScores[roundID][playerID][holeNumber];
    if (!holeScore || holeScore.strokes == null) return 9999;
    return holeScore.strokes;
  }

  compareTieBreaker(playerIDA, playerIDB, roundID) {
    const round = this.rounds[roundID];
    if (!round) return 0;
    const course = this.courses[round.courseID];
    const holes = this.getHolesByHandicap(course, round);
    if (holes.length === 0) return 0;

    const compareCount = Math.min(3, holes.length);
    let aSum = 0;
    let bSum = 0;
    for (let i = 0; i < compareCount; i++) {
      aSum += this.getPlayerNetOnHole(playerIDA, roundID, holes[i].holeNumber);
      bSum += this.getPlayerNetOnHole(playerIDB, roundID, holes[i].holeNumber);
    }
    if (aSum !== bSum) return aSum - bSum;

    for (let i = compareCount; i < holes.length; i++) {
      const aNet = this.getPlayerNetOnHole(
        playerIDA,
        roundID,
        holes[i].holeNumber
      );
      const bNet = this.getPlayerNetOnHole(
        playerIDB,
        roundID,
        holes[i].holeNumber
      );
      if (aNet !== bNet) return aNet - bNet;
    }
    return 0;
  }

  setSortedPlayers() {
    var currentRound =
      this.currentRoundID && this.rounds[this.currentRoundID];
    if (!currentRound) {
      this.sortedPlayers = [];
      return;
    }
    var rounds = this.getCurrentRounds();
    var players = {};
    Object.keys(this.players).forEach((playerID) => {
      var player = { id: playerID, pictureURL: this.players[playerID].pictureURL };
      player.total = 9999;
      player.grossScore = 0;
      player.through = 0;
      rounds.forEach((round) => {
        if (round.id === currentRound.id) {
          if (round.groups && round.players && round.players[playerID]) {
            var roundPlayer = round.players[playerID];
            var groupID = roundPlayer.groupID;
            var roundGroup = round.groups[groupID];
            player.groupNumber = roundGroup ? roundGroup.groupNumber : -1;
            player.group = roundGroup;
          }
        }
        var playerScores = null;
        if (this.roundScores[round.id])
          playerScores = this.roundScores[round.id][playerID];
        if (playerScores) {
          var roundNet = 0;
          var hasRoundScores = false;
          for (var i = 0; i < 18; i++) {
            var hole = i + 1;
            if (playerScores[hole]) {
              if (playerScores[hole].strokes != null) {
                hasRoundScores = true;
                if (player.total === 9999) player.total = 0;
                player.grossScore += playerScores[hole].score || 0;
                player.total += playerScores[hole].strokes;
                roundNet += playerScores[hole].strokes;
              }
              //if current round log the last hole the player has a score for
              if (round.id === currentRound.id) {
                if (
                  playerScores[hole].strokes != null &&
                  hole > player.through
                ) {
                  player.through = hole;
                }
              }
            }
          }
          if (round.id === this.currentRoundID) {
            if (hasRoundScores) {
              player.currentRoundNet = roundNet;
              if (player.currentRoundNet > 0)
                player.currentRoundNetStr = "+" + player.currentRoundNet;
              if (player.currentRoundNet < 0)
                player.currentRoundNetStr = player.currentRoundNet;
              if (player.currentRoundNet === 0) player.currentRoundNetStr = "E";
            } else {
              player.currentRoundNetStr = "";
            }
          }
        }
      });
      players[player.id] = player;
    });
    var that = this;
    var playersArr = Object.keys(players).map((playerID) => players[playerID]);
    var sortedPlayers = playersArr.sort(function (a, b) {
      if (a.total !== b.total) {
        return a.total - b.total;
      }
      if (!that.rounds[that.currentRoundID] || !that.rounds[that.currentRoundID].players) return 0;
      var aGroupNumber = players[a.id].groupNumber;
      var bGroupNumber = players[b.id].groupNumber;
      if (!aGroupNumber) aGroupNumber = 999;
      if (!bGroupNumber) bGroupNumber = 999;
      if (aGroupNumber === bGroupNumber) {
        return 0;
      }
      if (aGroupNumber < bGroupNumber) {
        return -1;
      }
      return 1;
    });
    var place = 1;
    var lastScore = -99999;
    var prefix = null;
    var nextScore = null;
    sortedPlayers.forEach((player) => {
      player.position = "";
    });
    var rankedPlayers = sortedPlayers.filter(
      (player) => player.total !== 9999
    );
    rankedPlayers.forEach((player, index) => {
      prefix = "";
      nextScore = -1;
      if (index < rankedPlayers.length - 1) {
        nextScore = rankedPlayers[index + 1].total;
      }
      if (player.total > lastScore) {
        place = index + 1;
      }
      if (player.total === lastScore || player.total === nextScore) {
        prefix = "T";
      }
      player.position = prefix + place;
      lastScore = player.total;
    });
    sortedPlayers.forEach((player) => {
      if (!this.roundScores[ewtStore.currentRoundID]) {
        ewtStore.roundScores[ewtStore.currentRoundID] = {};
      }
      if (!this.roundScores[ewtStore.currentRoundID][player.id]) {
        ewtStore.roundScores[ewtStore.currentRoundID][player.id] = {};
      }
      if (player.position) {
        this.roundScores[ewtStore.currentRoundID][player.id]["P"] =
          player.position;
      }
      if (player.total > 0) player.totalStr = "+" + player.total;
      if (player.total < 0) player.totalStr = player.total;
      if (player.total === 0) player.totalStr = "E";
      if (player.total === 9999) player.totalStr = "";
      this.roundScores[this.currentRoundID][player.id]["N"] =
        player.total === 9999 ? "" : player.total;
      this.roundScores[this.currentRoundID][player.id]["NS"] = player.totalStr;
      if (this.players[player.id]) {
        this.players[player.id].position = player.position || "";
      }
    });
    this.sortedPlayers = sortedPlayers;
  }

  deleteOneDoc(collectionName, docID) {
    this.firebaseDB.collection(collectionName).doc(docID).delete();
  }

  deleteScore(hole) {
    if (
      this.roundScores[hole.roundID] &&
      this.roundScores[hole.roundID][hole.playerID] &&
      this.roundScores[hole.roundID][hole.playerID][hole.num]
    ) {
      var score = this.roundScores[hole.roundID][hole.playerID][hole.num];
      this.firebaseDB.collection("scores").doc(score.id).delete();
    }
  }

  async setScore(roundID, playerID, holeNumber, newScore) {
    var that = this;
    return new Promise(function (resolve, reject) {
      if (
        that.roundScores[roundID] &&
        that.roundScores[roundID][playerID] &&
        that.roundScores[roundID][playerID][holeNumber]
      ) {
        var score = that.roundScores[roundID][playerID][holeNumber];
        that.firebaseDB
          .collection("scores")
          .doc(score.id)
          .update({
            score: newScore,
          })
          .then((doc) => {
            resolve();
          });
      } else {
        var score2 = {
          roundID: roundID,
          playerID: playerID,
          hole: holeNumber,
          tournamentID: that.tournament.id,
          score: newScore,
        };
        that.firebaseDB
          .collection("scores")
          .add(score2)
          .then((doc) => {
            resolve();
          });
      }
    });
  }

  async ensureCourse(courseID) {
    if (!courseID) return null;
    if (!this.courses) this.courses = {};
    if (this.courses[courseID]) return this.courses[courseID];
    const course = await this.getOneDoc("courses", courseID);
    if (course) {
      course.id = courseID;
      this.courses[courseID] = course;
    }
    return course;
  }

  async loadCoursesForTournament() {
    if (!this.rounds) return;
    const courseIDs = new Set();
    Object.keys(this.rounds).forEach((roundID) => {
      const courseID = this.rounds[roundID].courseID;
      if (courseID) courseIDs.add(courseID);
    });
    await Promise.all(
      [...courseIDs].map((courseID) => this.ensureCourse(courseID))
    );
  }

  async setCourse(courseID) {
    if (!courseID) {
      this.course = null;
      return;
    }
    const course = await this.ensureCourse(courseID);
    this.course = course;
    if (!course) alert("invalid courseID" + courseID);
    if (!this.fanMode) this.calcGroup();
  }

  setFanMode(mode) {
    ewtStore.fanMode = mode;
    this.player = null;
    if (!mode) this.fanTournaments = null;
    if (mode) this.setCookieValue("playerID", "");
    this.setCookieValue("fanMode", mode);
    if (mode) this.currentView = "leaderboard";
  }

  updateOneDoc(collectionName, id, obj) {
    var that = this;
    return new Promise(function (resolve, reject) {
      that.firebaseDB
        .collection(collectionName)
        .doc(id)
        .update(obj)
        .then((doc) => {
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async getNextSequentialId(collectionName) {
    const snapshot = await this.firebaseDB.collection(collectionName).get();
    let maxId = 0;
    snapshot.docs.forEach((doc) => {
      const id = parseInt(doc.id, 10);
      if (!isNaN(id) && id > maxId) maxId = id;
    });
    return (maxId + 1).toString();
  }

  setOneDoc(collectionName, id, obj) {
    var that = this;
    return new Promise(function (resolve, reject) {
      that.firebaseDB
        .collection(collectionName)
        .doc(id)
        .set(obj)
        .then(() => {
          resolve(id);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async getAllPlayers() {
    const snapshot = await this.firebaseDB
      .collection("players")
      .orderBy("last_name")
      .orderBy("first_name")
      .get();
    return snapshot.docs.map((doc) => {
      const player = doc.data();
      player.id = doc.id;
      return player;
    });
  }

  openPlayerCard(player) {
    let cardPlayer =
      (this.players && this.players[player.id]) || { ...player };
    if (
      this.currentRoundID &&
      this.rounds &&
      this.rounds[this.currentRoundID]
    ) {
      cardPlayer.showRound = this.rounds[this.currentRoundID];
    }
    this.showPlayerCard = cardPlayer;
  }

  async openPlayerEdit(playerOrTemplate) {
    let player = playerOrTemplate;
    if (playerOrTemplate && playerOrTemplate.id) {
      const fresh = await this.getOneDoc("players", playerOrTemplate.id);
      if (fresh) {
        fresh.id = playerOrTemplate.id;
        player = fresh;
      }
    }
    this.editPlayer = JSON.parse(JSON.stringify(player));
    this.playerEditKey += 1;
    this.showPlayerEdit = true;
  }

  closePlayerEdit() {
    this.showPlayerEdit = false;
    this.editPlayer = null;
  }

  async savePlayer(player) {
    const toSave = { ...player };
    delete toSave.tournamentHandicaps;
    delete toSave.id;

    if (typeof player.tournaments === 'string') {
      toSave.tournaments = player.tournaments
        .split(',')
        .map((id) => id.trim())
        .filter((id) => /^\d+$/.test(id));
    } else {
      toSave.tournaments = (player.tournaments || []).filter((id) =>
        /^\d+$/.test(String(id))
      );
    }
    const cleanHandicaps = { ...(toSave.handicaps || {}) };
    Object.keys(player.tournamentHandicaps || {}).forEach((key) => {
      if (!/^\d+$/.test(key)) return;
      const val = player.tournamentHandicaps[key];
      if (val === "" || val === null || val === undefined) {
        delete cleanHandicaps[key];
        return;
      }
      const parsed = parseFloat(val);
      if (!isNaN(parsed)) cleanHandicaps[key] = parsed;
    });
    toSave.handicaps = cleanHandicaps;

    if (player.id) {
      await this.updateOneDoc("players", player.id, toSave);
      if (this.players && this.players[player.id]) {
        Object.assign(this.players[player.id], toSave);
        this.players[player.id].id = player.id;
      }
      if (this.player && this.player.id === player.id) {
        this.player.handicaps = { ...cleanHandicaps };
      }
      if (this.tournament) {
        this.recalculateScoresForPlayer(player.id, this.tournament.id);
      }
      return { ...toSave, id: player.id };
    }

    const newID = await this.getNextSequentialId("players");
    toSave.org = "1";
    toSave.tournaments = toSave.tournaments || [];
    toSave.handicaps = toSave.handicaps || {};
    if (toSave.first_name && toSave.last_name && !toSave.code) {
      toSave.code =
        toSave.first_name.substr(0, 2).toUpperCase() +
        toSave.last_name.substr(0, 1).toUpperCase() +
        newID;
    }
    await this.setOneDoc("players", newID, toSave);
    return { ...toSave, id: newID };
  }

  getNextRoundGroupId(groups) {
    let maxId = 0;
    Object.keys(groups || {}).forEach((groupID) => {
      const id = parseInt(groupID, 10);
      if (!isNaN(id) && id > maxId) maxId = id;
      const groupNumber = parseInt(groups[groupID].groupNumber, 10);
      if (!isNaN(groupNumber) && groupNumber > maxId) maxId = groupNumber;
    });
    return (maxId + 1).toString();
  }

  normalizeStartingHole(value) {
    const hole = parseInt(value, 10);
    if (isNaN(hole) || hole < 1 || hole > 18) return 1;
    return hole;
  }

  getGroupStartingHole(roundID) {
    const round = this.rounds && this.rounds[roundID];
    if (!round) return 1;
    const fromGroup = this.group && this.group.startingHole;
    return this.normalizeStartingHole(fromGroup || round.startingHole || "1");
  }

  getHolePlayOrder(startHole) {
    const start = this.normalizeStartingHole(startHole);
    const order = [];
    for (let i = 0; i < 18; i++) {
      order.push(((start - 1 + i) % 18) + 1);
    }
    return order;
  }

  getLastHoleInPlayOrder(startHole) {
    const order = this.getHolePlayOrder(startHole);
    return order[17];
  }

  getNextHoleInPlayOrder(currentHole, startHole) {
    const order = this.getHolePlayOrder(startHole);
    const idx = order.indexOf(currentHole);
    if (idx < 0) return this.normalizeStartingHole(startHole);
    if (idx >= 17) return null;
    return order[idx + 1];
  }

  getPrevHoleInPlayOrder(currentHole, startHole) {
    const order = this.getHolePlayOrder(startHole);
    const idx = order.indexOf(currentHole);
    if (idx <= 0) return null;
    return order[idx - 1];
  }

  calcGroupScoringHole(roundID) {
    if (this.fanMode) return 1;
    const startHole = this.getGroupStartingHole(roundID);
    if (!this.groupPlayers || this.groupPlayers.length === 0) return startHole;
    const playOrder = this.getHolePlayOrder(startHole);
    if (!this.roundScores || !this.roundScores[roundID]) {
      return startHole;
    }
    for (let i = 0; i < playOrder.length; i++) {
      const hole = playOrder[i];
      for (let g = 0; g < this.groupPlayers.length; g++) {
        const player = this.groupPlayers[g];
        if (!player) continue;
        const playerScores = this.roundScores[roundID][player.id];
        if (!playerScores || !playerScores[hole]) {
          return hole;
        }
      }
    }
    return this.getLastHoleInPlayOrder(startHole);
  }

  getSelectableScoringHoles(roundID) {
    const startHole = this.getGroupStartingHole(roundID);
    const playOrder = this.getHolePlayOrder(startHole);
    const nextHole = this.calcGroupScoringHole(roundID);
    const nextIndex = playOrder.indexOf(nextHole);
    if (nextIndex < 0) return playOrder.slice(0, 1);
    return playOrder.slice(0, Math.min(nextIndex + 2, 18));
  }

  buildNewRoundGroup(roundID) {
    const round = this.rounds[roundID];
    if (!round) return null;
    const newGroupID = this.getNextRoundGroupId(round.groups);
    return {
      id: newGroupID,
      groupNumber: newGroupID,
      teeTime: "",
      startingHole: round.startingHole || "1",
    };
  }

  async isPlayerInOtherRoundGroups(tournamentID, playerID, roundID) {
    const snapshot = await this.firebaseDB
      .collection("rounds")
      .where("tournamentID", "==", tournamentID)
      .get();
    for (const doc of snapshot.docs) {
      if (doc.id === roundID) continue;
      const data = doc.data();
      if (data.players && data.players[playerID]) return true;
    }
    return false;
  }

  async addPlayerToTournament(playerID, tournamentID) {
    const player = await this.getOneDoc("players", playerID);
    if (!player) return;
    const tournaments = player.tournaments || [];
    if (tournaments.includes(tournamentID)) return;
    await this.updateOneDoc("players", playerID, {
      tournaments: [...tournaments, tournamentID],
    });
  }

  async removePlayerFromTournamentIfUnassigned(
    playerID,
    tournamentID,
    roundID
  ) {
    const stillAssigned = await this.isPlayerInOtherRoundGroups(
      tournamentID,
      playerID,
      roundID
    );
    if (stillAssigned) return;
    const player = await this.getOneDoc("players", playerID);
    if (!player || !player.tournaments) return;
    const tournaments = player.tournaments.filter((id) => id !== tournamentID);
    await this.updateOneDoc("players", playerID, { tournaments });
  }

  async saveRoundGroup(roundID, groupID, groupFields, assignedPlayerIDs) {
    const round =
      this.rounds[roundID] || (await this.getOneDoc("rounds", roundID));
    if (!round) return;
    const tournamentID = round.tournamentID || this.tournament.id;
    const groups = { ...(round.groups || {}) };
    const players = { ...(round.players || {}) };
    const slotPlayerIDs = (assignedPlayerIDs || []).filter(Boolean);

    groups[groupID] = {
      ...(groups[groupID] || {}),
      id: groupID,
      groupNumber: String(groupFields.groupNumber),
      teeTime: groupFields.teeTime || "",
      startingHole: groupFields.startingHole || "1",
    };

    const previousInGroup = Object.keys(players).filter(
      (playerID) => players[playerID].groupID === groupID
    );

    for (const playerID of previousInGroup) {
      if (!slotPlayerIDs.includes(playerID)) {
        delete players[playerID];
        await this.removePlayerFromTournamentIfUnassigned(
          playerID,
          tournamentID,
          roundID
        );
      }
    }

    for (const playerID of slotPlayerIDs) {
      players[playerID] = { groupID: groupID };
      await this.addPlayerToTournament(playerID, tournamentID);
      if (!this.players || !this.players[playerID]) {
        const player = await this.getOneDoc("players", playerID);
        if (player) {
          player.id = playerID;
          player.pictureURL = null;
          if (!this.players) this.players = {};
          this.players[playerID] = player;
          this.loadPlayerPicture(
            tournamentID,
            playerID,
            this.playersPictureLoadGeneration
          );
        }
      }
    }

    await this.updateOneDoc("rounds", roundID, { groups, players });
    if (this.rounds[roundID]) {
      this.rounds[roundID] = { ...this.rounds[roundID], groups, players };
    }
    if (this.currentRoundID === roundID && !this.fanMode) {
      this.calcGroup();
    }
    if (this.initialized) {
      this.setSortedPlayers();
    }
  }

  async savePlayerHandicap(playerID, tournamentID, handicap) {
    const player = await this.getOneDoc("players", playerID);
    if (!player) return;
    const handicaps = { ...(player.handicaps || {}) };
    if (handicap === "" || handicap === null || handicap === undefined) {
      delete handicaps[tournamentID];
    } else {
      const parsed = parseFloat(handicap);
      if (isNaN(parsed)) return;
      handicaps[tournamentID] = parsed;
    }
    await this.updateOneDoc("players", playerID, { handicaps });
    if (this.players && this.players[playerID]) {
      this.players[playerID].handicaps = handicaps;
    }
    if (this.player && this.player.id === playerID) {
      this.player.handicaps = { ...handicaps };
    }
    if (this.tournament && tournamentID === this.tournament.id) {
      this.recalculateScoresForPlayer(playerID, tournamentID);
    }
  }

  addOneDoc(collectionName, obj) {
    var that = this;
    return new Promise(function (resolve, reject) {
      that.firebaseDB
        .collection(collectionName)
        .add(obj)
        .then((doc) => {
          resolve(doc.id);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  getOneDoc(collectionName, id) {
    var that = this;
    return new Promise(function (resolve, reject) {
      that.firebaseDB
        .collection(collectionName)
        .doc(id)
        .get()
        .then((doc) => {
          if (!doc.exists) {
            resolve(null);
            return;
          }
          var obj = doc.data();
          obj.id = doc.id;
          resolve(obj);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  async setCurrentRound(roundID) {
    await this.updateOneDoc("tournaments", this.tournament.id, {
      currentRoundID: roundID,
    });
    return new Promise(function (resolve, reject) {
      // that.setSortedPlayers();
      resolve();
    });
  }

  async getAllDocs(collectionName) {
    const snapshot = await this.firebaseDB.collection(collectionName).get();
    return snapshot.docs.map(doc => { let x = doc.data();x.id = doc.id;return x});
  }

  async applyTournamentRound(tournament) {
    const requestedRoundID = tournament && tournament.currentRoundID;
    const round = requestedRoundID && this.rounds[requestedRoundID];
    if (round) {
      this.currentRoundID = requestedRoundID;
      this.currentRound = round;
      await this.setCourse(round.courseID);
      if (!this.fanMode) this.calcGroup();
    } else {
      this.currentRoundID = null;
      this.currentRound = {};
      this.course = null;
    }
  }

  async setTournament(tournamentID, tournament, change) {
    if (change && this.tournament && tournamentID === this.tournament.id) return;
    this.initialized = false;
    this.sortedPlayers = null;
    this.unsubscribeScores();
    this.unsubscribeTournament();
    this.unsubscribeRounds();
    if (!tournament)
      tournament = await this.getOneDoc("tournaments", tournamentID);
    if (!tournament) return false;
    const orgID = tournament.orgID || "1";
    if (!this.org || this.org.id !== orgID) {
      await this.setOrg(orgID, null);
    }
    this.tournament = tournament;
    await Promise.all([
      this.loadPlayers(tournament),
      this.initializeRounds(tournament),
    ]);
    this.loadAllPlayerPictures(
      tournament.id,
      this.playersPictureLoadGeneration
    );
    await this.applyTournamentRound(tournament);
    await this.loadCoursesForTournament();
    await this.initializeScores(tournament);
    this.initialized = true;
    this.setSortedPlayers();
    var that = this;
    that.tournamentSnapshotUnsubscribe = that.firebaseDB
      .collection("tournaments")
      .doc(tournamentID)
      .onSnapshot(function (doc) {
        if (!doc.exists) return;
        (async function () {
          var t = doc.data();
          t.id = doc.id;
          const requestedRoundID = t.currentRoundID;
          const round = requestedRoundID && that.rounds[requestedRoundID];
          const prevRoundID = that.currentRoundID;
          const nextRoundID = round ? requestedRoundID : null;
          const recalc = prevRoundID !== nextRoundID;
          that.tournament = t;
          that.currentRoundID = nextRoundID;
          that.currentRound = round || {};
          if (round && round.courseID) {
            await that.setCourse(round.courseID);
          } else {
            that.course = null;
          }
          if (!that.fanMode && that.currentRoundID) that.calcGroup();
          if (recalc) {
            await that.refreshScoresSubscription(that.tournament);
          }
          that.setSortedPlayers();
        })().catch(function (err) {
          console.error("tournament snapshot", err);
        });
      });
    return true;
  }
  async loadAllTournaments(force) {
    if (this.fanMode) return [];
    if (!force && this.allTournaments) return this.allTournaments;
    this.playerFullTournamentsLoading = true;
    try {
      const snapshot = await this.firebaseDB.collection("tournaments").get();
      const tournaments = snapshot.docs
        .map((doc) => {
          const tournament = doc.data();
          tournament.id = doc.id;
          return tournament;
        })
        .sort((a, b) => parseInt(b.id, 10) - parseInt(a.id, 10));
      this.allTournaments = tournaments;
      return tournaments;
    } finally {
      this.playerFullTournamentsLoading = false;
    }
  }

  async loadFanTournaments(force) {
    if (!this.fanMode) return [];
    if (!force && this.fanTournaments) return this.fanTournaments;
    this.playerFullTournamentsLoading = true;
    try {
      const snapshot = await this.firebaseDB.collection("tournaments").get();
      const tournaments = snapshot.docs
        .map((doc) => {
          const tournament = doc.data();
          tournament.id = doc.id;
          return tournament;
        })
        .filter((tournament) => tournament.fan_code)
        .sort((a, b) => parseInt(b.id, 10) - parseInt(a.id, 10));
      this.fanTournaments = tournaments;
      return tournaments;
    } finally {
      this.playerFullTournamentsLoading = false;
    }
  }

  getSelectTournamentList() {
    if (this.fanMode) return this.fanTournaments || [];
    return this.allTournaments || [];
  }

  async setPlayer(playerID, player) {
    var that = this;
    return new Promise(async function (resolve, reject) {
      if (ewtStore.fanMode) {
        resolve();
        return;
      }
      if (!player) {
        player = await that.getOneDoc("players", playerID);
      }
      if (!player) {
        resolve();
        return;
      }
      if (player.admin) that.adminUser = true;
      that.setCookieValue("playerID", player.id);
      that.player = player;
      resolve();
    });
  }
  valueInArray(arr, value) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === value) return i;
    }
    return null;
  }
  isInitialized() {
    return this.initialized;
  }
  getNet(playerID, course, round, holeNumber, score) {
    if (!this.players[playerID]) return;
    var playerHandicap = this.players[playerID].handicaps
      ? this.players[playerID].handicaps[this.tournament.id]
      : 0;
    return this.getNetWithHandicap(
      playerHandicap,
      course,
      round,
      holeNumber,
      score
    );
  }

  getNetWithHandicap(playerHandicap, course, round, holeNumber, score) {
    if (!course || !round || !course.holes || !course.holes[holeNumber]) return 0;
    if (playerHandicap == null || playerHandicap === "") playerHandicap = 0;
    var courseHole = course.holes[holeNumber];
    var tees = round.tees;
    var tee = courseHole.tees[tees];
    if (!tee) return score - (courseHole.par || 0);
    if (score > tee.par * 2) score = tee.par * 2;
    var strokesReceived = this.getHandicapStrokesOnHole(
      playerHandicap,
      course,
      round,
      holeNumber
    );
    return score - tee.par - strokesReceived;
  }

  buildPlayerRoundScores(round, course, holeScoreMap, playerHandicap) {
    const result = { holes: {} };
    if (!course || !round) return result;
    let gross = 0;
    let netSum = 0;
    for (let h = 1; h <= 18; h++) {
      const score = holeScoreMap && holeScoreMap[h];
      if (score == null || score === "") continue;
      const tee =
        course.holes &&
        course.holes[h] &&
        course.holes[h].tees &&
        course.holes[h].tees[round.tees];
      if (!tee || tee.par == null) continue;
      const strokes = this.getNetWithHandicap(
        playerHandicap,
        course,
        round,
        h,
        score
      );
      if (strokes == null) continue;
      gross += score;
      netSum += tee.par + strokes;
      result.holes[h] = { score, strokes, par: tee.par };
    }
    result.gross = gross || "";
    result.net = netSum || "";
    if (playerHandicap != null && playerHandicap !== "") {
      result.handicap = playerHandicap;
    }
    return result;
  }

  buildPlayerCardDisplayScores(history, playerID, rounds) {
    const displayScores = { ...(history.computedScores || {}) };
    if (!history || !playerID || !rounds || !rounds.length) return displayScores;

    const persisted = history.playerScoresByRound || {};
    const liveByRound = this.getScoresFromStore(
      playerID,
      rounds.map((round) => round.id)
    );

    rounds.forEach((round) => {
      const holeMap = {
        ...(persisted[round.id] || {}),
        ...(liveByRound[round.id] || {}),
      };
      if (!Object.keys(holeMap).length) return;

      const course =
        history.coursesById[round.courseID] ||
        (this.courses && this.courses[round.courseID]);
      if (!course) return;

      const handicap =
        history.player &&
        history.player.handicaps &&
        history.player.handicaps[round.tournamentID] != null
          ? history.player.handicaps[round.tournamentID]
          : 0;

      const built = this.buildPlayerRoundScores(
        round,
        course,
        holeMap,
        handicap
      );
      if (Object.keys(built.holes).length > 0) {
        displayScores[round.id] = built;
      }
    });

    return displayScores;
  }

  formatRoundLabel(tournament, round) {
    const label = (tournament && tournament.name) || (tournament && tournament.id) || "";
    if (round.practice) return `${label} Pr`;
    if (round.shortName) return `${label} ${round.shortName}`;
    if (round.name && /rd/i.test(round.name)) return `${label} ${round.name}`;
    if (round.roundNumber != null && round.roundNumber !== "")
      return `${label} Rd ${round.roundNumber}`;
    return `${label} ${round.name || round.id}`;
  }

  parseRoundDate(round) {
    if (!round || !round.date) return 0;
    const parsed = parseRoundDate(round.date);
    return parsed ? parsed.valueOf() : 0;
  }

  async loadPlayerCardMeta(playerID) {
    const player = await this.getOneDoc("players", playerID);
    if (!player) return null;
    player.id = playerID;

    const tournamentIDs = (player.tournaments || []).filter((id) =>
      /^\d+$/.test(String(id))
    );
    const tournamentDocs = await Promise.all(
      tournamentIDs.map(async (tid) => {
        const tournament = await this.getOneDoc("tournaments", tid);
        if (!tournament) return null;
        tournament.id = tid;
        return tournament;
      })
    );
    const tournaments = tournamentDocs
      .filter(Boolean)
      .sort((a, b) =>
        String(b.name || b.id).localeCompare(String(a.name || a.id))
      );

    const coursesById = {};
    if (this.courses) {
      Object.keys(this.courses).forEach((courseID) => {
        coursesById[courseID] = this.courses[courseID];
      });
    }

    return {
      player,
      tournaments,
      roundsByTournament: {},
      allRounds: [],
      scoresByRound: {},
      coursesById,
      computedScores: {},
      loadedTournaments: {},
      playerScoresByRound: null,
      playerScoresLoaded: false,
    };
  }

  async ensurePlayerScores(cache) {
    if (cache.playerScoresLoaded) return cache.playerScoresByRound;
    const snapshot = await this.firebaseDB
      .collection("scores")
      .where("playerID", "==", cache.player.id)
      .get();
    const playerScoresByRound = {};
    snapshot.docs.forEach((doc) => {
      const score = doc.data();
      const hole = parseInt(score.hole, 10);
      if (!score.roundID || !hole) return;
      if (!playerScoresByRound[score.roundID]) {
        playerScoresByRound[score.roundID] = {};
      }
      playerScoresByRound[score.roundID][hole] = score.score;
    });
    cache.playerScoresByRound = playerScoresByRound;
    cache.playerScoresLoaded = true;
    Object.assign(cache.scoresByRound, playerScoresByRound);
    return playerScoresByRound;
  }

  async ensureCourses(cache, courseIDs) {
    const missing = courseIDs.filter((id) => id && !cache.coursesById[id]);
    await Promise.all(
      missing.map(async (courseID) => {
        const course = await this.getOneDoc("courses", courseID);
        if (course) {
          course.id = courseID;
          cache.coursesById[courseID] = course;
        }
      })
    );
  }

  mergeTournamentIntoCache(cache, tournament, rounds, scoresByRound) {
    cache.roundsByTournament[tournament.id] = rounds;
    const handicap =
      cache.player.handicaps && cache.player.handicaps[tournament.id]
        ? cache.player.handicaps[tournament.id]
        : 0;
    rounds.forEach((round) => {
      cache.computedScores[round.id] = this.buildPlayerRoundScores(
        round,
        cache.coursesById[round.courseID],
        scoresByRound[round.id],
        handicap
      );
    });
  }

  rebuildAllRounds(cache) {
    const allRounds = [];
    cache.tournaments.forEach((tournament) => {
      (cache.roundsByTournament[tournament.id] || []).forEach((round) => {
        allRounds.push({ ...round, tournament });
      });
    });
    allRounds.sort((a, b) => {
      const dateDiff = this.parseRoundDate(b) - this.parseRoundDate(a);
      if (dateDiff !== 0) return dateDiff;
      return parseInt(b.roundNumber, 10) - parseInt(a.roundNumber, 10);
    });
    cache.allRounds = allRounds;
  }

  getRoundsFromStore(tournamentID) {
    if (!this.rounds || this.tournament?.id !== tournamentID) return null;
    return Object.keys(this.rounds)
      .map((roundID) => ({
        ...this.rounds[roundID],
        id: roundID,
        tournamentID,
      }))
      .sort(
        (a, b) => parseInt(a.roundNumber, 10) - parseInt(b.roundNumber, 10)
      );
  }

  getScoresFromStore(playerID, roundIDs) {
    if (!this.roundScores) return {};
    const scoresByRound = {};
    roundIDs.forEach((roundID) => {
      const live = this.roundScores[roundID] && this.roundScores[roundID][playerID];
      if (!live) return;
      scoresByRound[roundID] = {};
      for (let hole = 1; hole <= 18; hole++) {
        if (live[hole] && live[hole].score != null) {
          scoresByRound[roundID][hole] = live[hole].score;
        }
      }
    });
    return scoresByRound;
  }

  mergeRoundScoresForPlayer(cache, playerID, roundIDs) {
    const scoresByRound = {};
    const persisted = cache.playerScoresByRound || {};
    const live = this.getScoresFromStore(playerID, roundIDs);
    roundIDs.forEach((roundID) => {
      const merged = {
        ...(persisted[roundID] || {}),
        ...(live[roundID] || {}),
      };
      if (Object.keys(merged).length) {
        scoresByRound[roundID] = merged;
      }
    });
    return scoresByRound;
  }

  async loadPlayerTournamentHistory(cache, tournamentID) {
    const tournament = cache.tournaments.find((t) => t.id === tournamentID);
    if (!tournament) return cache;

    const storeRounds = this.getRoundsFromStore(tournamentID);
    if (cache.loadedTournaments[tournamentID] && !storeRounds) {
      return cache;
    }

    let rounds = storeRounds;
    if (!rounds) {
      const snapshot = await this.firebaseDB
        .collection("rounds")
        .where("tournamentID", "==", tournamentID)
        .orderBy("roundNumber")
        .get();
      rounds = snapshot.docs.map((doc) => {
        const round = doc.data();
        round.id = doc.id;
        round.tournamentID = tournamentID;
        return round;
      });
    }

    await this.ensurePlayerScores(cache);
    const scoresByRound = this.mergeRoundScoresForPlayer(
      cache,
      cache.player.id,
      rounds.map((round) => round.id)
    );

    rounds.forEach((round) => {
      if (round.courseID && this.courses && this.courses[round.courseID]) {
        cache.coursesById[round.courseID] = this.courses[round.courseID];
      }
    });

    const courseIDs = rounds.map((round) => round.courseID).filter(Boolean);
    await this.ensureCourses(cache, courseIDs);
    this.mergeTournamentIntoCache(cache, tournament, rounds, scoresByRound);
    cache.loadedTournaments[tournamentID] = true;
    return cache;
  }

  async loadPlayerAllTournamentHistories(cache) {
    await this.ensurePlayerScores(cache);
    const unloaded = cache.tournaments.filter(
      (tournament) => !cache.loadedTournaments[tournament.id]
    );
    await Promise.all(
      unloaded.map((tournament) =>
        this.loadPlayerTournamentHistory(cache, tournament.id)
      )
    );
    if (this.tournament) {
      await this.loadPlayerTournamentHistory(cache, this.tournament.id);
    }
    this.rebuildAllRounds(cache);
    return cache;
  }
  playerPictureKey(tournamentID, playerID) {
    return tournamentID + "/" + playerID;
  }

  loadAllPlayerPictures(tournamentID, generation) {
    var that = this;
    return that.firebaseStorage
      .ref("images/playerpics/t" + tournamentID)
      .listAll()
      .then(function (result) {
        if (generation !== that.playersPictureLoadGeneration) return;
        const withPhoto = {};
        const tasks = result.items.map(function (itemRef) {
          const match = itemRef.name.match(/^pp(.+)\.png$/);
          if (!match) return Promise.resolve();
          const playerID = match[1];
          withPhoto[playerID] = true;
          return itemRef.getDownloadURL().then(function (url) {
            if (generation !== that.playersPictureLoadGeneration) return;
            if (!that.players || !that.players[playerID]) return;
            that.players[playerID].pictureURL = url;
            delete that.playerPicturesMissing[
              that.playerPictureKey(tournamentID, playerID)
            ];
          });
        });
        return Promise.all(tasks).then(function () {
          if (generation !== that.playersPictureLoadGeneration) return;
          if (that.players) {
            Object.keys(that.players).forEach(function (playerID) {
              const key = that.playerPictureKey(tournamentID, playerID);
              if (!withPhoto[playerID]) {
                that.playerPicturesMissing[key] = true;
                if (that.players[playerID].pictureURL) {
                  that.players[playerID].pictureURL = null;
                }
              }
            });
          }
        });
      })
      .then(function () {
        if (generation !== that.playersPictureLoadGeneration) return;
        if (that.initialized) that.setSortedPlayers();
      })
      .catch(function (error) {
        console.warn("Could not list player photos:", error && error.message);
      });
  }

  loadPlayerPicture(tournamentID, playerID, generation, force) {
    var that = this;
    const key = that.playerPictureKey(tournamentID, playerID);
    if (!force && that.playerPicturesMissing[key]) {
      return Promise.resolve();
    }
    return that.firebaseStorage
      .ref("images/playerpics/t" + tournamentID)
      .child("pp" + playerID + ".png")
      .getDownloadURL()
      .then(function (url) {
        if (generation !== that.playersPictureLoadGeneration) return;
        if (!that.players || !that.players[playerID]) return;
        if (!that.tournament || that.tournament.id !== tournamentID) return;
        delete that.playerPicturesMissing[key];
        that.players[playerID].pictureURL = url;
        if (that.initialized) that.setSortedPlayers();
      })
      .catch(function () {
        if (generation !== that.playersPictureLoadGeneration) return;
        if (!that.players || !that.players[playerID]) return;
        if (!that.tournament || that.tournament.id !== tournamentID) return;
        that.playerPicturesMissing[key] = true;
        that.players[playerID].pictureURL = null;
        if (that.initialized) that.setSortedPlayers();
      });
  }

  applyPlayerDoc(player, playerID) {
    player.id = playerID;
    const prev = this.players && this.players[player.id];
    player.pictureURL = prev ? prev.pictureURL : null;
    if (!player.initials) {
      player.initials =
        player.first_name.substr(0, 1) + player.last_name.substr(0, 1);
    }
    if (!player.shortName) {
      player.shortName = player.first_name.substr(0, 1) + ". " + player.last_name;
      for (const pid of Object.keys(this.players || {})) {
        const p = this.players[pid];
        if (p.id !== player.id && p.shortName && p.shortName === player.shortName) {
          player.shortName =
            player.first_name.substr(0, 2) + ". " + player.last_name;
          p.shortName = p.first_name.substr(0, 2) + ". " + p.last_name;
        }
      }
    }
    if (!this.players) this.players = {};
    this.players[player.id] = player;
  }

  loadPlayers(tournament) {
    if (this.playersSnapshotUnsubscribe) {
      this.playersSnapshotUnsubscribe();
      this.playersSnapshotUnsubscribe = null;
    }
    this.playersPictureLoadGeneration += 1;
    const generation = this.playersPictureLoadGeneration;
    const tournamentID = tournament.id;
    this.players = {};
    var that = this;
    return (async function () {
      const snapshot = await ewtStore.firebaseDB
        .collection("players")
        .where("tournaments", "array-contains", tournamentID)
        .get();
      if (generation !== that.playersPictureLoadGeneration) return;
      snapshot.docs.forEach(function (doc) {
        that.applyPlayerDoc(doc.data(), doc.id);
      });
      that.loadAllPlayerPictures(tournamentID, generation);
      that.playersSnapshotUnsubscribe = ewtStore.firebaseDB
        .collection("players")
        .where("tournaments", "array-contains", tournamentID)
        .onSnapshot((snap) => {
          if (generation !== that.playersPictureLoadGeneration) return;
          const changes = snap.docChanges();
          changes.forEach(function (change) {
            if (change.type === "removed") {
              delete that.players[change.doc.id];
            } else {
              that.applyPlayerDoc(change.doc.data(), change.doc.id);
            }
          });
          if (that.initialized) {
            that.setSortedPlayers();
          }
          changes.forEach(function (change) {
            if (change.type === "added") {
              that.loadAllPlayerPictures(tournamentID, generation);
            }
          });
        });
    })();
  }
}
decorate(EWTStore, {
  players: observable,
  scores: observable,
  tournament: observable,
  chatMessages: observable,
  org: observable,
  rounds: observable,

  groupPlayers: observable,
  player: observable,
  roundScores: observable,
  sortedPlayers: observable,

  course: observable,
  showPlayerCard: observable,
  showPlayerEdit: observable,
  editPlayer: observable,
  currentView: observable,
  editRounds: observable,
  gallery: observable,
  unread: observable,
  correctScore: observable,
  showHole: observable,
  showFullPic: observable,
  holeMapURL: observable,
  showCourseMap: observable,
  showCourseCard: observable,
  showTieBreaker: observable,
  showPairings: observable,
  showPlayers: observable,
  showItinerary: observable,

  windowWidth: observable,
  showView: observable,
  windowHeight: observable,

  showMap: observable,
  golfcourseImageURL: observable,
  courseMapURL: observable,
  currentRoundID: observable,
  currentRound: observable,
  mapIconURL: observable,

  fanMode: observable,
  allTournaments: observable,
  fanTournaments: observable,
  initialized: observable,
  adminUser: observable,
  logoURL: observable,
  deferredInstallPrompt: observable,
  usingKeyboad: observable,
  firstRoundID: observable,
  isInitialized: observable,
  selectTournament: observable,
  playerFullTournamentsLoading: observable,
});

const ewtStore = new EWTStore();
//ewtStore.players = ["fred","bob"]
export default ewtStore;
